<template lang="pug">
  #warning.mb-5(v-bind:style="{ display: active ? 'block' : 'none' }")
    v-container(fluid)
      v-dialog(v-model="active" max-width="700" persistent)
        v-card
          v-card-title.headline
            v-icon(color="yellow darken-2") warning
            span ¿Quieres {{data.action}} {{data.entityGenre == 'm' ? 'el' : 'la'}} {{data.entity}}?
            v-card-text Al realizar esta acción se actualizarán todos los casos con {{data.entityGenre == 'm' ? 'este' : 'esta'}} {{data.entity}}.
          v-card-actions
            v-spacer
            v-btn(color="red darken-1" text @click.native="discard()") Cancelar
            v-btn(color="green darken-1" text @click.native="agree()") Aceptar

</template>
<script>
export default {
  name: "ChangeDialog",
  props: ['data'],
  data() {
    return {
      active: false,
      resolve: undefined
    };
  },
  methods: {
    pop() {
      this.active = true;
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    agree() {
      this.active = false;
      this.resolve(true);
    },
    discard() {
      this.active = false;
      this.resolve(false);
    }
  }
};
</script>
<style lang="scss" scoped>
.headline {
  font-size: 20px;
  span {
    color: #ffbf00;
    margin-left: 5px;
  }
}
</style>
